export default {
  listHeaders() {
    return [
      { text: 'Personel Bilgileri', value: 'proje' },
      { text: 'İzin Türü', value: 'FullName' },
      { text: 'Süre', value: 'TCIdentificationNumber' },
      { text: 'Başlangıç', value: 'FatherName' },
      { text: 'Bitiş', value: 'FatherName' },
      { text: 'Reddet', value: 'Buttons' },
      { text: 'Onayla', value: 'Buttons' },
    ];
  },
};
